export const SESSION_QUERY_KEY = ['session'];
export const ORGANIZATION_QUERY_KEY = ['organization'];
export const INFINITE_NOTIFICATIONS_QUERY_KEY = ['infinite_notifications'];
export const USER_PREFERENCES_QUERY_KEY = ['user_preferences'];
export const USER_GLOBAL_PREFERENCES_QUERY_KEY = ['user_global_preferences'];
export const UNSEEN_COUNT_QUERY_KEY = ['unseen_count'];
export const UNREAD_COUNT_QUERY_KEY = ['unread_count'];
export const FEED_UNSEEN_COUNT_QUERY_KEY = ['feed_unseen_count'];
